import React from 'react';

const TwoSections = () => (
  <section className="bg-dark bg-two-step u-py-100">
    <div className="container text-center text-white">
      <div className="row">
        <div className="col-md-6">
          <div className="d-flex u-w-80 u-h-80 rounded-circle u-flex-center text-primary mx-auto u-fs-36">
            <span>
              <img src="/images/svg/vespa-icon.svg" alt="Vespa" style={{ width: '250px' }} />
            </span>
          </div>
          <h4 className="text-white u-my-35">Postanite član 'Vespa klub Rijeka'!</h4>
          <p>
            Ako posjedujete Vespu i uživate u druženju i vožnji,{' '}
            <a href="/prijava" style={{ textDecoration: 'underline' }}>
              popunite prijavu
            </a>{' '}
            i postanite član našeg kluba.
          </p>
          <a href="/prijava" className="btn btn btn-rounded btn-white ml-lg-3">
            <i className="fa fa-register mr-1" /> UČLANITE SE
          </a>
        </div>
        <div className="col-md-6">
          <div className="d-flex u-w-80 u-h-80 rounded-circle u-flex-center text-primary mx-auto u-fs-36">
            <span>
              <img src="/images/svg/vespa-icon.svg" alt="Vespa" style={{ width: '250px' }} />
            </span>
          </div>
          <h4 className="text-white mb-5">Samo za članove kluba</h4>
          <p className="mb-5">
            Za sve aktualne informacije o aktivnostima kluba, logirajte se sa vašim '@vespaklubrijeka.com' accountom.
            Ukoliko ste zaboravili pristupne podatke, kontaktirajte administratora web site-a na
            admin@vespaklubrijeka.com.
          </p>
          <a href="/members" className="btn btn btn-rounded btn-white ml-lg-3">
            <i className="fa fa-sign-in mr-1" /> LOGIRAJTE SE
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default TwoSections;



// WEBPACK FOOTER //
// ./src/components/TwoSections.js